import { Box } from "@/components/ui/box";
import type { ReactNode } from "react";

export interface CardProps {
  children: ReactNode;
  className?: string;
}

export const Card = ({ children, className }: CardProps) => {
  return (
    <Box className={`bg-primary-100 border border-outline-300 gap-[20px] px-[20px] py-[32px] rounded-[12px] shadow-[0_8px_20px_rgba(0,0,0,.05)] ${className}`}>
      {children}
    </Box>
  );
};
